import { render, staticRenderFns } from "./Cabinets.vue?vue&type=template&id=8f9b6358"
import script from "./Cabinets.vue?vue&type=script&lang=ts"
export * from "./Cabinets.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports